<template>

    <a-menu
        mode="inline"
        :openKeys="openKeys"
        v-model:selectedKeys="selectedKeys"
        style="width: 100%"
        @click="handleClick"
        >
        <a-sub-menu key="myOrder">
            <template #title>
                <span class='title_cont'><img src='@assets/img/menu1.png' class='icon'><span>我的订单</span></span>
            </template>
            <a-menu-item key="orderList" @click='toMenu("orderList")'>火车票订单</a-menu-item>
            <!-- <a-menu-item key="ticket">飞机票订单</a-menu-item> 暂时没有飞机票 -->
        </a-sub-menu>
       <!-- <a-sub-menu key="commonInfo">
            <template #title>
                <span class='title_cont'><img src='@assets/img/menu2.png' class='icon'><span>常用信息</span></span>
            </template>
            <a-menu-item key="passengers" @click='toMenu("passenger")'>乘客管理</a-menu-item>
        </a-sub-menu>-->
        <a-sub-menu key="moneyManage">
            <template #title>
                <span class='title_cont'><img src='@assets/img/menu3.png' class='icon'><span>资金管理</span></span>
            </template>
            <a-menu-item key="recharge" @click='toMenu("amountList")'>资金流水</a-menu-item>
            <a-menu-item key="billList" @click='toMenu("billList")'>帐单汇总</a-menu-item>
            <a-menu-item key="offlineBillList" @click='toMenu("offlineBillList")'>线下票帐单汇总</a-menu-item>
           <!-- <a-menu-item key="rechargeDetail" @click='toMenu("rechargeDetail")'>充值记录</a-menu-item>-->
        </a-sub-menu>
        <a-sub-menu key="platform" v-if='menuList.length'>
            <template #title>
                <span class='title_cont'><img src='@assets/img/menu4.png' class='icon'><span>开放平台</span></span>
            </template>

            <a-menu-item v-for='(item,index) in menuList' key="platform" @click='toMenu("platform",item.id)'>{{item.businessName}}网关</a-menu-item>

        </a-sub-menu>
    </a-menu>
</template>
<script>
import { useRouter,useRoute } from 'vue-router'
import { ref,watch } from 'vue'
import { MailOutlined, AppstoreOutlined, SettingOutlined } from '@ant-design/icons-vue'
import commonApi from '@axios/common'

export default {
    componentname: "menu",
    components: {
        MailOutlined,
        AppstoreOutlined,
        SettingOutlined,
    },
    props:{

    },
    setup(props,{ emit }){
        let openKeys = ref(['myOrder','commonInfo','moneyManage','platform'])
        let selectedKeys = ref([])
        const { currentRoute } = useRouter();
        const router = useRouter();

        const setSelectedKeys = () => {
            if(currentRoute.value.name == 'orderDetail' || currentRoute.value.name == 'orderList' ||  currentRoute.value.name == 'orderRefund' ||  currentRoute.value.name == 'endorsed'){
                selectedKeys.value = ['orderList'];
            }


            if(currentRoute.value.name == 'amountList'){
                selectedKeys.value = ['recharge'];
            }

            if(currentRoute.value.name == 'billList'){
                selectedKeys.value = ['billList'];
            }

          if(currentRoute.value.name == 'offlineBillList'){
            selectedKeys.value = ['offlineBillList'];
          }

            if(currentRoute.value.name == 'rechargeDetail'){
                selectedKeys.value = ['rechargeDetail'];
            }


            if(currentRoute.value.name == 'passenger'){
                selectedKeys.value = ['passengers'];
            }

            if(currentRoute.value.name == 'platform'){
                selectedKeys.value = ['platform'];
            }
        }
        setSelectedKeys()


        watch(currentRoute,(val)=>{
            setSelectedKeys()
        })

        let menuList = ref([])

        const getUrlMenu = () => {
            commonApi.getMenu().then((res)=>{
                menuList.value = res;
            })
        }

        getUrlMenu();


        const handleClick = (e) => {

        }

        const toMenu = (name,id) => {
            if(name == 'platform'){
                router.push({
                    name : name,
                    query : {
                        id : id
                    }
                })
                return;
            }
            router.push({
                name : name
            })
        }

        return {
            menuList,
            handleClick,
            openKeys,
            selectedKeys,
            toMenu,
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .icon{
        width: 15px;
        height: 15px;
        margin-right: 10px;
        position: relative;
        top:-1px;
    }
    .title_cont{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size:16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
    }

</style>
